import {
  SelectFilter,
  TypeaheadFilter,
  TabFilter,
  SelectDaterangeFilter,
  TextFilter,
  InputDateFilter,
  TypeaheadMultiSelectFilter,
  DateRangeFilter,
  MultiSelectFilter,
  SwitchFilter,
  CheckboxFilter,
  NumberStepperFilter,
  RadioFilter,
  RelativeDateRangeFilter,
  CheckboxGroupFilter
} from "../components";
import BucketRangeFilter from "@/features/control-tower/components/BucketRangeFilter/BucketRangeFilter.vue";

export const FILTER_TYPES = {
  SELECT: "select",
  TYPEAHEAD: "typeahead",
  TAB: "tab",
  SELECT_DATERANGE: "select-daterange",
  TEXT: "text",
  INPUT_DATE: "input-date",
  DATE_RANGE: "date-range",
  TYPEAHEAD_MULTISELECT: "typeahead-multiselect",
  MULTI_SELECT: "multi-select",
  SWITCH: "switch",
  CHECKBOX: "checkbox",
  NUMBER_STEPPER: "number-stepper",
  RADIO: "radio",
  BUCKET_RANGE: "bucket-range",
  RELATIVE_DATERANGE: "relative-daterange",
  CHECKBOX_GROUP: "checkbox-group"
};

export const QUICK_FILTERS = {
  DATE_TYPE: "dateType",
  DATE_RANGE: "daterange",
  START_DATE: "startDate",
  END_DATE: "endDate"
};

export const getComponentByType = (type: string) => {
  switch (type) {
    case FILTER_TYPES.SELECT:
      return SelectFilter;
    case FILTER_TYPES.TYPEAHEAD:
      return TypeaheadFilter;
    case FILTER_TYPES.TAB:
      return TabFilter;
    case FILTER_TYPES.SELECT_DATERANGE:
      return SelectDaterangeFilter;
    case FILTER_TYPES.TEXT:
      return TextFilter;
    case FILTER_TYPES.INPUT_DATE:
      return InputDateFilter;
    case FILTER_TYPES.DATE_RANGE:
      return DateRangeFilter;
    case FILTER_TYPES.TYPEAHEAD_MULTISELECT:
      return TypeaheadMultiSelectFilter;
    case FILTER_TYPES.MULTI_SELECT:
      return MultiSelectFilter;
    case FILTER_TYPES.SWITCH:
      return SwitchFilter;
    case FILTER_TYPES.CHECKBOX:
      return CheckboxFilter;
    case FILTER_TYPES.NUMBER_STEPPER:
      return NumberStepperFilter;
    case FILTER_TYPES.RADIO:
      return RadioFilter;
    case FILTER_TYPES.RELATIVE_DATERANGE:
      return RelativeDateRangeFilter;
    case FILTER_TYPES.CHECKBOX_GROUP:
      return CheckboxGroupFilter;
    case FILTER_TYPES.BUCKET_RANGE:
      return BucketRangeFilter;
    default:
      return null;
  }
};
